var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#001b46;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.308,3.692A.694.694,0,0,0,10.616,3H3.692A.694.694,0,0,0,3,3.692v6.924a.694.694,0,0,0,.692.692h6.924a.694.694,0,0,0,.692-.692Z",
    transform: "translate(-3 -3)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M25.308,3.692A.694.694,0,0,0,24.616,3H17.692A.694.694,0,0,0,17,3.692v6.924a.694.694,0,0,0,.692.692h6.924a.694.694,0,0,0,.692-.692Z",
    transform: "translate(-7.308 -3)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.692,25.308h6.923a.694.694,0,0,0,.692-.692V17.692A.694.694,0,0,0,24.616,17H17.692a.694.694,0,0,0-.692.692v6.923A.694.694,0,0,0,17.692,25.308Z",
    transform: "translate(-7.308 -7.308)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.616,17H3.692A.694.694,0,0,0,3,17.692v6.923a.694.694,0,0,0,.692.692h6.923a.694.694,0,0,0,.692-.692V17.692A.694.694,0,0,0,10.616,17Z",
    transform: "translate(-3 -7.308)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.3d0f695e.svg";
export { ForwardRef as ReactComponent };